module.exports = __webpack_public_path__ + "static/media/furniture-design-2.3fd967b5.png";